import * as Sentry from "@sentry/browser";

Sentry.init({
  dsn: window.env.sentryDsn,
  environment: window.env.environment ?? "production",
});
